<template>
  <main class="content">
      <div class="row">
          <h1>
              Edit city
          </h1>
      </div>
      <form action="" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
          <fieldset class="form--item">
              <label class="label" for="">
                  City:
              </label>
              <div class="input_text">
                  <input name="" placeholder="Write a city name" type="text" required v-model="city.name"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Timezone:
              </label>
              <div class="input_text">
                  <v-select v-model="city.timezone" required :searchable="false" placeholder="Click to select a Timezone" :options="timezones"></v-select>
              </div>
          </fieldset>
          <div class="row">
              <a class="btn btn_green u-fleft u-mr1" @click="updatePartner()">
                  Update
              </a>
              <a class="btn btn_red u-fleft" @click="confirmToggle()">
                  Delete
              </a>
          </div>
      </form>
      <confirm resource="city" :visible.sync="alertVisible"></confirm>
      <ok resource="city" resource-plural="cities" :visible.sync="okVisible"></ok>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as EditResource from '../../mixins/editResource.mixin';
import * as ValidateForm from '../../mixins/validate-form.mixin';

import Confirm from '../Modals/modal_confirm';
import Ok from '../Modals/modal_ok';
import Loading from '../Loading.vue'
import Message from '../Message.vue'
import vSelect from "vue-select"

const moment = require('moment-timezone');;

export default {
  name: 'EditCities',
  components: { Confirm, Ok, Message, Loading, vSelect },
  mixins: [ValidateForm, EditResource],
  data () {
    return {
      model: 'city',
      resource: 'cities',
      parentResource: 'Cities',
      alertVisible: false,
      okVisible: false,
      city: {},
      timezones: moment.tz.names()
    }
  },
  created(){
    this.fetchResource(this.$route.params.id, {});
  },
  methods: {
    updatePartner(){
      this.updateResource(this.$route.params.id, this.city);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditCities.vue?4e7129b2